import { FormExtractorService } from '../../../../shared/services/form-extractor.service';
import { LogService } from '../../../../shared/services/log.service';
import { Validator } from '../../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../../ctrl.name.extractor';

export class CTRL_2003 implements Validator {

    public static id = 'CTRL_2003';
    private message = 'error.ctr_2003';


    public LOG: LogService = new LogService(CTRL_2003);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_2003.id + '_');

        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const firstChamp = map.get(ctrl.value.rgCtrls.firstChamp);
                const secondChamp= map.get(ctrl.value.rgCtrls.secondChamp);
                const firstCtrl = form.controls[firstChamp];
                const secondCtrl = form.controls[secondChamp];

                if (this.isEmptyOrNullOrUndefined(firstCtrl.value) && !this.isEmptyOrNullOrUndefined(secondCtrl.value)) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }

    isEmptyOrNullOrUndefined(value): boolean{
		return (value === undefined || value === null || value === '');
	}
}
